import React from 'react';
import { Flex, Row, List, Tabs } from 'antd';
import { ProfileOutlined, FormOutlined, TeamOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import UserList from './user-list';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [shopId, setShopId] = React.useState(null);

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);

    return (
        <div>
            <SwitchShop />
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                {/* <NavItem href="/account/sub-create" text="创建账号">
                    <FormOutlined style={iconStyle} />
                </NavItem> */}

                <NavItem href="/account/create" text="创建账号">
                    <FormOutlined style={iconStyle} />
                </NavItem>

                {!window.__baseInfo.isSub && <NavItem href="/account/role" text="角色管理">
                    <TeamOutlined style={iconStyle} />
                </NavItem>}

                <NavItem href="/account/profile" text="账户资料">
                    <ProfileOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <h2>账号列表</h2>
            <UserList shopId={shopId} />
        </div>
    )
}